/** Static product module catalog; must match backend `ALLOWED_PRODUCT_MODULE_CODES`. */

export const PRODUCT_MODULES = [
  { code: "CONTRACTS", label: "Contracts" },
  { code: "RFP", label: "RFP" },
  { code: "PRIZE_RULES", label: "Prize Rules" }
] as const;

export type ProductModuleCode = (typeof PRODUCT_MODULES)[number]["code"];

export const productModuleLabel = (code: string): string =>
  PRODUCT_MODULES.find((m) => m.code === code)?.label ?? code;
